import styled from '@emotion/styled'
import { Table, TableContainer } from '@mui/material'
import theme from 'theme'

export const TableContainerW = styled(TableContainer)<{ height?: string; hideoverflow?: string }>`
  background: ${theme.colors.surfaceContainerBackground};
  //max-height: calc(100vh - 400px);
  max-height: calc(100vh - 366px);
  width: 100%;
  overflow-x: auto;

  ${({ height }) =>
    height &&
    `
    height: ${height};
  `}

  ${({ hideoverflow }) =>
    hideoverflow &&
    hideoverflow === 'true' &&
    `
    overflow: hidden !important;
  `}

  ::-webkit-scrollbar {
    width: 4px;
    background: transparent;
  }

  ::-webkit-scrollbar-track {
    box-shadow: none;
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${theme.colors.cta};
    border-radius: ${theme.attributes.borderRadius.quaternary};
  }
`

export const TableWrapper = styled(Table)`
  thead th {
    color: ${theme.colors.textSecondary};
    text-overflow: ellipsis;
    font-size: ${theme.typography.fontSize.xLarge};
    font-style: normal;
    font-weight: ${theme.typography.fontWeight.normal};
    line-height: normal;
    padding: 9px ${theme.spacing.sm}px;
    border-top: 1px solid ${theme.colors.strokePrimary};
    border-left: 1px solid ${theme.colors.strokePrimary};
    border-bottom: 1px solid ${theme.colors.strokePrimary};
    background: ${theme.colors.surfaceContainerBackground};
    white-space: nowrap;
    cursor: pointer;

    &:last-child {
      border-right: 1px solid ${theme.colors.strokePrimary};
    }

    .row-wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: ${theme.spacing.small}px;

      .row-header-text {
        overflow: hidden;
        color: ${theme.colors.textSecondary};
        text-overflow: ellipsis;
        font-size: ${theme.typography.fontSize.xLarge};
        font-style: normal;
        font-weight: ${theme.typography.fontWeight.normal};
        line-height: normal;
      }

      .icon-wrapper {
        display: flex;
        cursor: pointer;
      }

      .desc-icon {
        transform: rotate(180deg);
      }
    }
  }

  .no-padding {
    padding-right: 2px;
  }

  tbody tr {
    &:hover {
      background-color: ${theme.colors.cardFillTertiary};
      border-bottom-color: ${theme.colors.strokePrimary};
    }
  }

  tbody tr {
    cursor: pointer;
  }

  tbody td {
    padding: 11px ${theme.spacing.xSmall}px;
    border-left: 1px solid ${theme.colors.strokePrimary};
    border-bottom: 1px solid ${theme.colors.strokePrimary};
    color: ${theme.colors.foreground};
    text-overflow: ellipsis;
    font-size: ${theme.typography.fontSize.xLarge};
    font-style: normal;
    font-weight: ${theme.typography.fontWeight.normal};
    line-height: normal;
    height: 60px;

    &.loading-cell-wrapper {
      .MuiSkeleton-root {
        border-radius: ${theme.attributes.borderRadius.large};

        &:after {
          background: linear-gradient(
            90deg,
            rgba(255, 255, 255, 0) 15.32%,
            rgba(255, 255, 255, 0.35) 49.89%,
            rgba(255, 255, 255, 0) 83.78%
          );
        }
      }

      &:after {
        background: linear-gradient(
          90deg,
          rgba(255, 255, 255, 0) 15.32%,
          rgba(255, 255, 255, 0.35) 49.89%,
          rgba(255, 255, 255, 0) 83.78%
        );
      }
    }

    .coverage-wrapper {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: ${theme.spacing.small}px;

      img {
        width: 24px;
        height: 24px;
      }
    }

    &:last-child {
      border-right: 1px solid ${theme.colors.strokePrimary};
    }

    .cell-wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: ${theme.spacing.md}px;

      .ellipsis {
        @media (max-width: 1440px) {
          width: 90%;
        }

        &.empty-cell {
          color: ${theme.colors.devicesEmptyCell};
        }
      }

      .count {
        cursor: pointer;
        color: ${theme.colors.textSecondary};

        &:hover {
          color: ${theme.colors.cta};
        }
      }
    }
  }
`
